import { render, staticRenderFns } from "./LinkResultsGroup.vue?vue&type=template&id=463cb779&scoped=true&"
import script from "./LinkResultsGroup.vue?vue&type=script&lang=js&"
export * from "./LinkResultsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463cb779",
  null
  
)

export default component.exports